
import {
  defineComponent,
  ref,
  onMounted,
  watch,
  nextTick,
} from '@vue/composition-api';

import Definitions from '@/definitions';
import {
  multiOmicsForm, multiOmicsFormValid, multiOmicsAssociations, checkJGITemplates, canEditSubmissionMetadata, addAwardDoi, removeAwardDoi,
  templateHasData,
} from '../store';
import { AwardTypes, HARMONIZER_TEMPLATES } from '@/views/SubmissionPortal/types';

import SubmissionDocsLink from './SubmissionDocsLink.vue';
import SubmissionPermissionBanner from './SubmissionPermissionBanner.vue';
import DataTypes from './DataTypes.vue';
import DoeFacility from './DoeFacility.vue';

const OTHER = 'OTHER';

export default defineComponent({
  components: {
    DataTypes,
    DoeFacility,
    SubmissionDocsLink,
    SubmissionPermissionBanner,
  },
  setup() {
    const formRef = ref();

    function reValidate() {
      formRef.value.validate();
    }

    const projectAwardValidationRules = () => [(v: string | undefined) => {
      const facilityChosen = multiOmicsForm.facilities.length > 0;
      if (!facilityChosen) {
        return true;
      }
      const awardChosen = v !== undefined;
      if (!awardChosen) {
        return 'If submitting to a use facility, this field is required.';
      }
      return true;
    }];
    const otherAwardValidationRules = () => [(v: string | undefined) => {
      const facilityChosen = multiOmicsForm.facilities.length > 0;
      const awardChosen = multiOmicsForm.award !== undefined;
      if (!facilityChosen && !awardChosen) {
        return true;
      }
      if (!awardChosen || multiOmicsForm.award !== OTHER) {
        return true;
      }
      const inputEmpty = v === undefined || v.trim().length === 0;
      if (inputEmpty) {
        return 'Please enter the kind of project award.';
      }
      return true;
    }];
    const doiRequiredRules = () => [(v: string) => {
      const valid = !!v || (!multiOmicsForm.facilityGenerated && multiOmicsForm.dataGenerated) || (multiOmicsForm.unknownDoi && !multiOmicsForm.dataGenerated);
      return valid || 'An award DOI is required if data was or is going to be generated by a DOE facility.';
    }];
    const revalidate = () => {
      nextTick(() => formRef.value.validate());
    };

    function resetFields(field: string) {
      if (field === 'dataGenerated') {
        multiOmicsForm.facilityGenerated = undefined;
        multiOmicsForm.doe = undefined;
      }
      multiOmicsForm.award = undefined;
      multiOmicsForm.otherAward = undefined;
      multiOmicsForm.mgCompatible = undefined;
      multiOmicsForm.mgInterleaved = undefined;
      multiOmicsForm.omicsProcessingTypes = [];
      multiOmicsForm.mtCompatible = undefined;
      multiOmicsForm.mtInterleaved = undefined;
      multiOmicsForm.facilities = [];
      revalidate();
    }

    watch(
      () => multiOmicsForm.award,
      (award) => {
        const awardTypes = Object.values(AwardTypes) as string[];
        if (award && awardTypes.includes(award)) {
          multiOmicsForm.otherAward = '';
        }
        revalidate();
      },
    );

    onMounted(() => {
      formRef.value.validate();
    });

    return {
      OTHER,
      addAwardDoi,
      removeAwardDoi,
      projectAwardValidationRules,
      otherAwardValidationRules,
      doiRequiredRules,
      revalidate,
      resetFields,
      formRef,
      multiOmicsForm,
      multiOmicsAssociations,
      multiOmicsFormValid,
      Definitions,
      HARMONIZER_TEMPLATES,
      /* functions */
      reValidate,
      canEditSubmissionMetadata,
      checkJGITemplates,
      templateHasData,
    };
  },
});
